<template>
    <b-container fluid class="h-100">
        <b-row class="w-100 h-75">
            <b-col sm></b-col>
            <b-col sm style="margin:auto;">
                <div class="panel">
                    <div class="sidebar-header">
                        <b-img src="NS_logo.png" class="sidebar-logo"/>
                    </div>
                </div>
                <div class="panel">
                    <b-form class="welcome-form">
                        <p v-if="showErrors" class="text-danger text-center">{{showErrors}}</p>
                        <b-form-group>
                            <b-input-group>
                                <b-input-group-text><b-icon-at></b-icon-at></b-input-group-text>
                                <b-form-input name="" class="form-control" placeholder="Email" type="email" v-model.trim="loginForm.email"></b-form-input>
                            </b-input-group> <!-- input-group.// -->
                        </b-form-group> <!-- form-group// -->
                        <b-form-group>
                            <b-input-group>
                                <b-input-group-text><b-icon-lock></b-icon-lock></b-input-group-text>
                                <b-form-input class="form-control" type="password" placeholder="Password" autocomplete="off" v-model.trim="loginForm.password"></b-form-input>
                            </b-input-group> <!-- input-group.// -->
                        </b-form-group> <!-- form-group// -->
                        <div class="form-group">
                            <b-spinner v-if="logging" variant="primary" label="Spinning" style="margin:auto;"></b-spinner>
                            <b-button v-else type="submit" class="btn btn-primary btn-block" variant="success" @click="login">Accedi</b-button>
                        </div> <!-- form-group// -->

                    </b-form>
                </div>
            </b-col>
            <b-col sm></b-col>
        </b-row>
    </b-container>
</template>


<script>
    import { mapMutations } from 'vuex'

    export default {
        data () {
            return {
                loginForm: {
                    email: '',
                    password: ''
                },
                errors: null,
                logging:false
            }
        },
        computed: {
            showErrors () {
                return this.errors
            }
        },
        methods: {
            ...mapMutations(['setCurrentUser', 'setCurrentUserRole']),
            login: async function () {
                this.logging=true;
                try {
                    const user = await this.$firebase.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password);
                    // find user role in db try with firebase functions
                    let findUser = this.$firebase.functions.httpsCallable('findUser');
                    findUser({uid: user.user.uid}).then(function(result) {

                        let doc_data = result.data;
                        let user_data = {
                            id: user.user.uid,
                            lingua: doc_data.lingua,
                            nome: doc_data.nome,
                            role: doc_data.role
                        }
                        this.setCurrentUser(user.user);
                        this.setCurrentUserRole(user_data);
                        console.log(doc_data.home, user.user);
                        this.logging = false;
                        this.$router.push(doc_data.home);
                    }.bind(this));

                } catch (error) {
                    this.errors = error;
                    this.logging = false;
                }
            },
            updateLang: function (_lang) {
                console.log(_lang);
            },
        }
    }
</script>

<style scoped>

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .welcome-form{
        padding-top: 10px;
        margin: Auto;
        width: 85%;
    }

    .sidebar-header{
        max-width: 40%;
        margin: auto;
    }

    .sidebar-logo{
        width:100%;
        height:100%;
    }

</style>
